export default __webpack_public_path__ + "05aeec4744f1050112a16cd770d7a1b3.png";